import { createSlice } from "@reduxjs/toolkit";

const initialState = { transData: undefined, customerAddress: undefined, courier: undefined, insurance: 0 };
const offerSlice = createSlice({
    name: 'offer', initialState,
    reducers: {
        initTransaction: (state, action) => {
            const data = action?.payload
            state.transData = data?.transaction ?? undefined
            state.customerAddress = data?.address ?? undefined
        },
        setOffer: (state, action) => { state.transData = action?.payload ?? undefined },
        setOfferCourier: (state, action) => { state.courier = action?.payload ?? undefined },
        setOfferCourierInsurance: (state, action) => { state.insurance = action?.payload ?? 0 },
        setCustomerAddress: (state, action) => { state.customerAddress = action?.payload ?? undefined },
        clearOffer: () => ({ ...initialState })
    }
})

export const {
    initTransaction, setOffer,
    setOfferCourier,
    setOfferCourierInsurance,
    setCustomerAddress, clearOffer
} = offerSlice.actions;
export default offerSlice.reducer;